import { Col, Row } from '@ahmdigital/ui';
import React from 'react';

import {
  FilterBarWrapper,
  GridColumns,
  MobileWrapper,
  StyledButton,
  StyledDisclaimer,
  StyledFindClickable,
  StyledNavigationHeaderTitle,
  StyledStrong,
  TitleWrapper,
} from './styles';
import { ProductType } from '../../../../types/product';
import FilterBar from '../../../filter-bar';
import UpliftedHeader from './uplifted-header';

type DesktopHeaderFilterBarProps = {
  changeUrl: string;
  isCombiningHospitalWithExtras?: boolean;
  isProductListingPage?: boolean;
  isProductListingPageAdd?: boolean;
  isProductListingPageAll?: boolean;
  needsProductType?: ProductType['extrasType'];
  needsType?: string;
  products?: ProductType[];
  title: string;
  titlePrefix: string;
  titleSuffix: string;
  useHeading?: boolean;
};

const DesktopHeaderFilterBar = ({
  changeUrl,
  isCombiningHospitalWithExtras,
  isProductListingPage,
  isProductListingPageAdd,
  isProductListingPageAll,
  needsProductType,
  needsType,
  products,
  title,
  titlePrefix,
  titleSuffix,
  useHeading,
}: DesktopHeaderFilterBarProps) => (
  <FilterBarWrapper isProductPage={!isProductListingPage && !isProductListingPageAdd}>
    {isProductListingPage ? (
      <>
        {isProductListingPageAll && <UpliftedHeader needsType={needsType} products={products} />}
        {!isProductListingPageAll && (
          <>
            <TitleWrapper>
              <StyledNavigationHeaderTitle useHeading={useHeading}>
                <span data-testid="navigation-header-title">
                  {titlePrefix} <StyledStrong>{title}</StyledStrong> {titleSuffix}
                </span>
              </StyledNavigationHeaderTitle>
              {!isCombiningHospitalWithExtras && (
                <StyledFindClickable to={changeUrl}>Find something else</StyledFindClickable>
              )}
            </TitleWrapper>
            <FilterBar needsProductType={needsProductType} needsType={needsType} />
            <MobileWrapper>
              <StyledDisclaimer elementType="button" forProducts={products} highlightIncome showRefineLink={false} />
            </MobileWrapper>
          </>
        )}
      </>
    ) : (
      <GridColumns>
        <Row lgHorizontalAlign="center" verticalAlign="middle">
          <Col sm={12}>
            <StyledNavigationHeaderTitle useHeading={useHeading}>
              {titlePrefix} <StyledStrong>{title}</StyledStrong>
            </StyledNavigationHeaderTitle>
          </Col>
          {!isCombiningHospitalWithExtras && (
            <Col sm={12}>
              <StyledButton to={changeUrl} variant="white">
                Change this
              </StyledButton>
            </Col>
          )}
        </Row>
      </GridColumns>
    )}
  </FilterBarWrapper>
);

export default DesktopHeaderFilterBar;
